import React, { Component } from "react";
import { connect } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withRouter } from "../../../../utils/withRouter";
import Loader from "../../../../utils/Loader";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import { getAdminDelegateSummaryList_action } from "../../../../actions/admin_module_action/admin_dasboard_action/admin_dashboard_summary_action/admin_dashboard_summary_action";

class DelegateSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      summaryData: {},
    };
    this.getDelegateSummaryList = this.getDelegateSummaryList.bind(this);
    this.parseColumn = this.parseColumn.bind(this);
    this.renderTable = this.renderTable.bind(this);
  }

  componentDidMount() {
    this.getDelegateSummaryList();
  }

  getDelegateSummaryList() {
    this.setState({ isLoading: true });
    this.props
      .getAdminDelegateSummaryList_action()
      .then((res) => {
        if (res.error != 1) {
          console.log("Admin Delegate Summary ------->", res.data);
          this.setState({
            isLoading: false,
            summaryData: res.data || {},
          });
        } else {
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isLoading: false });
      });
  }

  parseColumn(key) {
    const stripped = key.replace(/Count$/i, "");
    const match = stripped.match(/^(.*?)(UnPaid|Paid)(.*)$/i);
    if (!match) {
      const label = stripped.replace(/([a-z])([A-Z])/g, "$1 $2").trim() || key;
      return { key, group: "", sub: label };
    }
    const [, before, paidType, after] = match;
    const isUnpaid = /unpaid/i.test(paidType);
    const paidLabel = isUnpaid ? "Unpaid/Incomplete" : "Paid/Complete";
    const spacedBefore = before.replace(/([a-z])([A-Z])/g, "$1 $2").trim();
    const spacedAfter = after.replace(/([a-z])([A-Z])/g, "$1 $2").trim();
    if (spacedBefore) {
      return { key, group: spacedBefore, sub: paidLabel };
    } else {
      return { key, group: paidLabel, sub: spacedAfter };
    }
  }

  renderTable(title, list) {
    const rows = Array.isArray(list) ? list : [];
    const resolvedTitle = rows.length > 0 && rows[0].Title ? rows[0].Title : title;
    const allKeys = rows.length > 0 ? Object.keys(rows[0]).filter((k) => k !== "Title") : [];

    const isNumericVal = (v) => v !== null && v !== "" && !isNaN(Number(v));
    const valueKeys = allKeys.filter((k) => isNumericVal(rows[0]?.[k]));
    const labelKeys = allKeys.filter((k) => !valueKeys.includes(k));

    const parsed = valueKeys.map((k) => this.parseColumn(k));

    const groups = [];
    parsed.forEach((p) => {
      const last = groups[groups.length - 1];
      if (last && last.group === p.group) last.cols.push(p);
      else groups.push({ group: p.group, cols: [p] });
    });

    const needsTwoRows = groups.some((g) => g.group && g.cols.length > 1);

    const colSum = (k) =>
      rows.reduce((s, row) => s + (Number(row[k]) || 0), 0);
    const rowSum = (row) =>
      valueKeys.reduce((s, k) => s + (Number(row[k]) || 0), 0);
    const grandTotal = rows.reduce((s, row) => s + rowSum(row), 0);

    const totalCols = 1 + labelKeys.length + valueKeys.length + 1;

    const stickyTh = {
      position: "sticky",
      top: 0,
      zIndex: 2,
      backgroundColor: "#f8f9fa",
    };
    const stickyThRow2 = {
      position: "sticky",
      top: needsTwoRows ? "37px" : 0,
      zIndex: 2,
      backgroundColor: "#f8f9fa",
    };

    return (
      <div className="col-12 mb-4">
        <div style={{ maxHeight: "300px", overflowY: "auto", border: "1px solid #dee2e6" }}>
          <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
            <thead>
              <tr>
                <th className="text-center" colSpan={totalCols} style={stickyTh}>
                  {resolvedTitle}
                </th>
              </tr>

              {needsTwoRows ? (
                <>
                  <tr>
                    <th className="text-center" rowSpan={2} style={stickyTh}>Sr No</th>
                    {labelKeys.map((k) => (
                      <th key={k} className="text-center" rowSpan={2} style={stickyTh}>{k}</th>
                    ))}
                    {groups.map((g, gi) =>
                      g.group ? (
                        <th key={gi} className="text-center" colSpan={g.cols.length} style={stickyTh}>
                          {g.group}
                        </th>
                      ) : (
                        g.cols.map((c) => (
                          <th key={c.key} className="text-center" rowSpan={2} style={stickyTh}>
                            {c.sub || c.key}
                          </th>
                        ))
                      ),
                    )}
                    <th className="text-center" rowSpan={2} style={stickyTh}>Total</th>
                  </tr>
                  <tr>
                    {groups.map((g) =>
                      g.group
                        ? g.cols.map((c) => (
                            <th key={c.key} className="text-center" style={stickyThRow2}>
                              {c.sub || c.group}
                            </th>
                          ))
                        : null,
                    )}
                  </tr>
                </>
              ) : (
                <tr>
                  <th className="text-center" style={stickyTh}>Sr No</th>
                  {labelKeys.map((k) => (
                    <th key={k} className="text-center" style={stickyTh}>{k}</th>
                  ))}
                  {parsed.map((c) => (
                    <th key={c.key} className="text-center" style={stickyTh}>
                      {c.group || c.sub || c.key}
                    </th>
                  ))}
                  <th className="text-center" style={stickyTh}>Total</th>
                </tr>
              )}
            </thead>

            <tbody>
              {rows.length > 0 ? (
                rows.map((row, i) => (
                  <tr key={i}>
                    <td className="text-center">{i + 1}</td>
                    {labelKeys.map((k) => (
                      <td key={k} className="text-center">{row[k]}</td>
                    ))}
                    {valueKeys.map((k) => (
                      <td key={k} className="text-center">{row[k]}</td>
                    ))}
                    <td className="text-center"><strong>{rowSum(row)}</strong></td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={totalCols} style={{ textAlign: "center" }}>
                    Record not found
                  </td>
                </tr>
              )}
            </tbody>

            {rows.length > 0 && (
              <tfoot>
                <tr style={{ position: "sticky", bottom: 0, backgroundColor: "#f8f9fa", zIndex: 2 }}>
                  <td className="text-center" colSpan={1 + labelKeys.length}>
                    <strong>Total</strong>
                  </td>
                  {valueKeys.map((k) => (
                    <td key={k} className="text-center">
                      <strong>{colSum(k)}</strong>
                    </td>
                  ))}
                  <td className="text-center">
                    <strong>{grandTotal}</strong>
                  </td>
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      </div>
    );
  }

  render() {
    const { isLoading, summaryData } = this.state;

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        <HeaderWithLogo />
        <>
          <AdminDrawer />
          <div className="admin-top-space">
            <div className="row mt-2 m-0">
              {Object.entries(summaryData).map(([key, list]) =>
                this.renderTable(
                  key.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/^./, (c) => c.toUpperCase()),
                  list,
                ),
              )}
            </div>
          </div>
        </>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    getAdminDelegateSummaryList_action,
  })(DelegateSummary),
);
